import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCountry16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCountry16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 14c.64 0 1.255-.1 1.833-.285v-1.423h-.916a2 2 0 0 1-2-2V7.706l.257-.143 4.993-2.774V3.683a6 6 0 0 0-2.208-1.356V4.81l-.277.137-1.167.584-.272.136-.246-.18L6 4.027v2.128a2 2 0 0 1-2 2H2.002A6 6 0 0 0 8 14M2.059 7.155H4a1 1 0 0 0 1-1V2.802a6 6 0 0 0-2.94 4.354m3.544-4.657a6 6 0 0 1 3.356-.422v2.115l-.62.308-2.545-1.862zm5.23 9.294v1.498a6 6 0 0 0 2.334-8.342v.43l-.258.142-4.992 2.774v1.998a1 1 0 0 0 1 1h1.916zM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCountry16);
